require("custom-event-polyfill");
require("./js/common/validator.js");
require("./js/common/form-labels.js");
require("./js/app.js");
require("./style.scss");
